import { PrefillData, PrefillPayload } from "../types";
import { SESSION_STORAGE_KEY } from "../constants";
import { parsePrefillData } from "../prefill_shared";

export function savePrefill(formEl: HTMLFormElement): void {
  try {
    const payload: PrefillPayload = {};
    document.querySelectorAll<HTMLInputElement>("[data-basket-param]").forEach((el) => {
      if (el.matches(":disabled")) return;
      if (el.type === "radio" || el.type === "checkbox") {
        if (!el.checked) return;
      }
      const key = el.dataset.basketParam;
      if (!key) return;
      const value =
        el.dataset.basketValue !== undefined && el.dataset.basketValue !== "" ? el.dataset.basketValue : el.value;
      payload[key] = value;
    });

    if (Object.keys(payload).length === 0) return;

    const listingEl = formEl.closest("[data-listing-code]");
    const activeListingCode = listingEl instanceof HTMLElement ? listingEl.dataset.listingCode : undefined;
    if (!activeListingCode) return;

    const existing = sessionStorage.getItem(SESSION_STORAGE_KEY)
      ? parsePrefillData(sessionStorage.getItem(SESSION_STORAGE_KEY))
      : {};
    const prefillData: PrefillData = {
      ...existing,
      [activeListingCode]: payload,
    };

    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(prefillData));
  } catch (e) {
    console.warn("[basket_param_prefill] skipped:", e);
  }
}
